import React, { PureComponent } from "react"

class Element extends PureComponent {
 
  render() {
    return (
      <div>Column</div>
    )
  }
}

export default Element
